import { Info, Prohibit } from "@phosphor-icons/react"
import React from "react"

export const  BlockUserNote = ({ remark = "" }) => {
  return (
    <div className="text-red-500 bg-red-50 p-4 font-600 rounded-lg border-solid border-l-4 border-y-0 border-r-0 border-red-500 mb-3">
      <div className="flex gap-2 items-center font-500">
        <Prohibit weight="fill" size={20} />
        User is Blocked
      </div>
      <div className="font-400 text-[14px] ml-6 my-2">{`${remark}`}</div>
      <div className="font-400 text-[10px] ml-6 flex gap-1 items-center">
        <Info size={10}/>
        You can modify their data, including farm, field, and plot entries. But
        you cannot use the user to create trades, schedules, or book demand.
      </div>
    </div>
  )
}
